export const HANABI_WEBSITE = 'https://hanabitech.com';

export const DOCUMENTATION = 'https://docs.hanabot.ai';

export const FEEDBACK_URL = `https://forms.gle/b311Vff2aKzxXqZn9`;

export const HANABI_PRIVACY_POLICY =
  'https://hana.hanabitech.com/privacy-policy';

export const HANABI_TERMS_AND_CONDITIONS =
  'https://hana.hanabitech.com/terms-of-service';

export const HANA_YOUTUBE_CHANNEL = 'https://www.youtube.com/@HanaAIBot';

export const HOW_TO_ADD_HANA_YOUTUBE_VIDEO =
  'https://youtu.be/6PgYEvKWKmw?si=PORK-C6k1jjpFnV5'; // New Onboarding Flow

export const YOUTUBE_PRIVACY_ENHANCED_EMBED_BASE_URL =
  'https://www.youtube-nocookie.com/embed/';

export const GOOGLE_CHAT_LINK = 'https://mail.google.com/chat/u/0/#chat/home';

export const GOOGLE_WORKSPACE_MARKETPLACE_URL =
  'https://workspace.google.com/marketplace/app/hana/646545989358';

export const HANA_PROMPT_LIBRARY_URL = 'https://www.hanabot.ai/chat-examples';

export const HANA_MEMORY_SETUP_DOCS_URL =
  'https://docs.hanabot.ai/docs/category/memory-module';

export const HANA_MEMORY_DOCS = {
  category: HANA_MEMORY_SETUP_DOCS_URL,
  common:
    'https://docs.hanabot.ai/docs/hana-dashboard-explained/memories/common-memory-module-info',
  general:
    'https://docs.hanabot.ai/docs/hana-dashboard-explained/memories/general-memory',
  googleDoc:
    'https://docs.hanabot.ai/docs/hana-dashboard-explained/memories/google-doc-memory',
  recursiveUrl:
    'https://docs.hanabot.ai/docs/hana-dashboard-explained/memories/recursive-url-memory',
  pdf: 'https://docs.hanabot.ai/docs/hana-dashboard-explained/memories/pdf-memory',
  autoResync:
    'https://docs.hanabot.ai/docs/hana-dashboard-explained/memories/auto-resync-memory',
  chatSpace:
    'https://docs.hanabot.ai/docs/hana-dashboard-explained/memories/google-chat-space-memory',
  chatSpaceAutoTracking:
    'https://docs.hanabot.ai/docs/hana-dashboard-explained/memories/google-chat-space-auto-tracking-memory',
  googleDrive:
    'https://docs.hanabot.ai/docs/hana-dashboard-explained/memories/google-drive-memory',
  docDocx:
    'https://docs.hanabot.ai/docs/hana-dashboard-explained/memories/doc-docx-memory',
} as const;

export const HANA_HEALTHCARE_CASE_STUDY_URL =
  'https://www.hanabot.ai/healthcare#case-study';

export const HANA_TECH_CASE_STUDY_URL =
  'https://www.hanabot.ai/#tech-case-study';

export const HANA_DISCORD_INVITE = 'https://discord.gg/SxDhTZy8zj';

export const ZAPIER_CONSOLE_URL = 'https://zapier.com/app/assets/zaps';

export enum COMMAND_USAGE_YOUTUBE_LINKS {
  remind = 'https://youtu.be/aHCtsx0vdkc?si=nFLcu09UV39ddwVd',

  memory = 'https://youtu.be/wn3YQL6kpho?si=6Pv-TspQBX1AV5Py',

  reportGroups = 'https://youtu.be/tDcUUbiV6aU?si=lq7kyn6zZKsT52iZ',

  browse = 'https://youtu.be/3Not7NyIqz4?si=CrQvU8IodGItlUPO',

  // feedback = '',

  // anonymousMessage = '',

  // lookback = '',

  tasks = 'https://youtu.be/kxpB5FIMYWs?si=lTaK9wq1bYSj3njM',

  calendar = 'https://youtu.be/Vl4hutXIaN4?si=53d1xX6QijdEOp-9',

  imageIntelligence = 'https://youtu.be/kHyf5T8XC7k?si=8yDx5tIbZufgseHv',

  // deferMessage = '',

  weather = 'https://youtu.be/KqALmns4gjs?si=OaubBjnvnHgZNcbS',

  docs = 'https://youtu.be/T6LdlRowsW8?si=PAaEQfcXrRO7POQ9',

  // ignoreChatHistory = '',

  pdf = 'https://youtu.be/Y1NEpmPd2mU?si=2oUUrXUuLgg1Mx-L',

  polls = 'https://youtu.be/6pHw50BnQdo?si=DHXdZsphNbnHY6pv',

  // MEET = '',
}

export enum CONNECTORS_YOUTUBE_LINKS {
  confluence = 'https://youtu.be/8a3baWujsxo',
}

export enum COMMAND_USAGE_DOCS {
  remind = 'https://docs.hanabot.ai/docs/tutorial-slash-commands/remind-command',

  memory = 'https://docs.hanabot.ai/docs/tutorial-slash-commands/memory-command',

  reportGroups = 'https://docs.hanabot.ai/docs/tutorial-slash-commands/reportgroups-command',

  browse = 'https://docs.hanabot.ai/docs/tutorial-slash-commands/browse-command',

  feedback = 'https://docs.hanabot.ai/docs/tutorial-slash-commands/feedback-command',

  anonymousMessage = 'https://docs.hanabot.ai/docs/tutorial-slash-commands/anonymousMessage-command',

  lookback = 'https://docs.hanabot.ai/docs/tutorial-slash-commands/lookback-command',

  tasks = 'https://docs.hanabot.ai/docs/tutorial-slash-commands/tasks-command',

  calendar = 'https://docs.hanabot.ai/docs/tutorial-slash-commands/calendar-command',

  imageIntelligence = 'https://docs.hanabot.ai/docs/tutorial-slash-commands/imageIntelligence-command',

  deferMessage = 'https://docs.hanabot.ai/docs/tutorial-slash-commands/deferMessage-command',

  weather = 'https://docs.hanabot.ai/docs/tutorial-slash-commands/weather-command',

  docs = 'https://docs.hanabot.ai/docs/tutorial-slash-commands/docs-command',

  ignoreChatHistory = 'https://docs.hanabot.ai/docs/tutorial-slash-commands/ignoreChatHistory-command',

  pdf = 'https://docs.hanabot.ai/docs/tutorial-slash-commands/pdf-command',

  polls = 'https://docs.hanabot.ai/docs/tutorial-slash-commands/polls-command',

  meet = 'https://docs.hanabot.ai/docs/tutorial-slash-commands/meet-command',
}

export enum CONNECTOR_DOCS {
  confluence = 'https://docs.hanabot.ai/docs/tutorial-connectors/confluence',
}

export const enum REALTIME {
  realtime = 'https://api.openai.com/v1/realtime',
}

export const CONFLUENCE_URL = {
  MANAGE_API_TOKEN:
    'https://support.atlassian.com/atlassian-account/docs/manage-api-tokens-for-your-atlassian-account/',
};
